import { useContext } from 'react';
import HomeContext from 'src/contexts/HomeContext/HomeContext';

const useHome = () => {
  return useContext(HomeContext);
};

export default useHome;
